import React from 'react';
import { componentService } from 'js/services/component.service';

export const FormTestComponent = React.lazy(() => import(/* webpackChunkName: "form-test-component" */ './FormTestComponent'));

componentService.registerWebContentComponents({ FormTestComponent });
